export const API_VERSION = "v1";

export function apiBase(): string {
    return `/api/${API_VERSION}`;
}



// WEBPACK FOOTER //
// ./src/actions/api.ts